var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSkill = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 68 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.818 0a4 4 0 0 1 2.889 1.172l30.682 30.683a4 4 0 0 1-5.656 5.656L37 13.78v20.686l29.39 29.39a4 4 0 0 1-5.657 5.656L37 45.78V83.5a4 4 0 1 1-8 0V45.957L6.913 69.424a4 4 0 1 1-5.826-5.483L29 34.284V13.957L6.913 37.424a4 4 0 1 1-5.826-5.482L29.965 1.259A4 4 0 0 1 32.818 0Z",
  fill: "#706DFF"
})));

export default SvgSkill;